import React, { Component } from 'react';
import PropTypes from 'prop-types';
import spriteIconGlass from '../styles/img/sprite.svg';

class ReferenceSearch extends Component {
  state = { text: '' }

  setText(text) {
    this.setState({ text });
  }

  handleKeyPress = (e) => {
    const { onFilter } = this.props;
    if (e.key === 'Enter') {
      const { text } = this.state;
      onFilter(text);
    }
  }

  handleChange = (e) => {
    this.setText(e.target.value);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { text } = this.state;
    const { onFilter } = this.props;
    if (!text) {
      return null;
    }
    onFilter(text);
    return null;
  }

  render() {
    const { text } = this.state;
    return (
      <form onSubmit={this.handleSubmit} className="search">
        <input
          type="text"
          className="search__input"
          placeholder="Search code references"
          onChange={this.handleChange}
          onKeyPress={this.handleKeyPress}
          value={text}
        />
        <button type="submit" className="search__button">
          <svg className="search__icon">
            <use xlinkHref={`${spriteIconGlass}#icon-magnifying-glass`} />
          </svg>
        </button>
      </form>
    );
  }
}
ReferenceSearch.propTypes = {
  onFilter: PropTypes.func.isRequired,
};

export default ReferenceSearch;
